import { ref } from 'vue'

export const mostRecentOrderText = ref('')
